<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="Router"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="Router"></router-view>
    <!-- <router-view/> -->
  </div>
</template>

<script>
export default {
  name: "App",
//   //在vue项目中的App.vue中添加公共的方法，这样只需要引入一次，其他页面只需要使用即可
// mounted(){
//         // 友盟统计添加
//         const script = document.createElement("script");
//         script.src =
//           "https://v1.cnzz.com/z_stat.php?id=1279610995&web_id=1279610995";   //该路径为点击统计代码后，页面中第一个 文字统计 script代码
//         script.language = "JavaScript";
//         document.body.appendChild(script);
// },

// watch: {
//       $route() {
//         if (window._czc) {
//           let location = window.location;
//           let contentUrl = location.pathname + location.hash;
//           let refererUrl = "/";
//           window._czc.push(["_trackPageview", contentUrl, refererUrl]);
//         }
//       }
// },



};
</script>

<style>
/* html,body{
  margin: 0;
  padding: 0;
} */
</style>
